module.exports = __webpack_public_path__ + "static/media/close-icon.a9c11900.svg";